"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var Typography_1 = __importDefault(require("../Typography"));
var react_1 = require("@emotion/react");
var defaultProps = {
    danger: false,
};
var getCSSRules = function (_a) {
    var colors = _a.colors;
    return ({
        dropdownMenuItem: {
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            height: 40,
            '&:hover': {
                backgroundColor: colors.Hannibal['100'],
            },
        },
        danger: {
            color: colors.Red['600'],
        },
    });
};
var DropdownMenuItem = function (props) {
    var style = props.style, children = props.children, danger = props.danger, onClick = props.onClick;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
            var _b, _c;
            var css = _a.css, cx = _a.cx;
            return ((0, jsx_runtime_1.jsx)("div", __assign({ css: styles.dropdownMenuItem, onClick: onClick, className: cx((_b = {}, _b[css(styles.danger)] = danger, _b)), style: style }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ style: { color: 'inherit' }, className: cx((_c = {}, _c[css(styles.danger)] = danger, _c)), component: "div", margin: 'none', variant: 'textMedium' }, { children: children }), void 0) }), void 0));
        } }, void 0));
};
DropdownMenuItem.defaultProps = defaultProps;
exports.default = DropdownMenuItem;
//# sourceMappingURL=DropdownMenuItem.js.map